





























import { IMarker } from "@/lib/interfaces/marker.interface";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop, Ref } from "vue-property-decorator";
import Debug from "../Debug.vue";
import MImageMarkerCanvas from "./MImageMarkerCanvas.vue";

@Component({
  components: { MImageMarkerCanvas, Debug }
})
export default class MImageMarker extends DarkModeHighlightMixin {
  @Prop() src!: string;
  @Prop({ default: "medium" }) markerSize!: "x-small" | "small" | "medium" | "large";
  @Prop() markers!: IMarker[];
  @Prop({ default: false }) deactivated!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: 300 }) maxHeight!: number;

  @Ref("imageContainer") imageContainer!: HTMLElement;

  containerWidth = window.innerWidth;

  mounted() {
    this.updateContainerWidth();
  }

  updateContainerWidth() {
    let containerWidth = this.imageContainer?.clientWidth;
    if (!containerWidth) {
      containerWidth = window.innerWidth;
    }
    if (containerWidth !== this.containerWidth) {
      this.containerWidth = containerWidth;
    }
  }

  forceUpdate() {
    this.$forceUpdate();
  }
}
